import React from "react";
import { EUBanner } from "../../../Banner/Banner";
import { cdn } from "../../../../consts/cdn";

//Images
const BannerDesktop = cdn.images + "Home/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "Home/Banner-Mobile.jpg";

function Home() {
  return (
    <>
      <div className="home">
        <EUBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          bold1="vNOTES"
          text1="The Next Evolution in Minimally"
          text2="Invasive Gynecologic Surgery"
          buttons={[
            {
              text: "Why vNOTES",
              route: "/eu/whyvnotes",
            },
            {
              text: "Patient Resources",
              route: "/eu/patientresources",
            },
          ]}
          color="#365B7E"
        />
      </div>
    </>
  );
}

export default Home;
